import {City} from '@/models/City';
import {District} from '@/models/District';
import {Media} from '@/models/Media';
import {Model, SimpleResponse} from '@/models/Model';
import {Province} from '@/models/Province';
import {DataArray, DataResource} from '@/models/Response';
import {Truck} from '@/models/Truck';
import Helper from '../services/Helper.js';


export class CustomerAddress extends Model {


    declare id: number;
    created_at: Date | null;
    updated_at: Date | null;
    name: string | null;
    address: string | null;
    customer_id: number;
    district_id: number | null;
    district: District | null;
    city_id: number | null;
    city: City | null;
    province_id: number | null;
    province: Province | null;
    zip_code: string | null;
    gis_is_confirm: boolean;
    gis_type: number;
    gis_lat: number | null;
    gis_lng: number | null;

    cache_lat: number | null;
    cache_lng: number | null;

    contact_name: string | null;
    contact_tel: string | null;

    medias: (Media)[] | null;

    getSkipField(): string[] {
        return ['timeline'];
    }

    getResourceURL(): string {
        return Helper.setting.customer_address.getResourceAPI;
    }
}

export class DataCustomerAddress extends DataResource {

    declare data: CustomerAddress;

}


export class DataCustomerAddressesArray extends DataArray {

    declare data: CustomerAddress[];

}


